import { render, staticRenderFns } from "./detailHeader.vue?vue&type=template&id=07f1dfc6&scoped=true&"
import script from "./detailHeader.vue?vue&type=script&lang=js&"
export * from "./detailHeader.vue?vue&type=script&lang=js&"
import style0 from "./detailHeader.vue?vue&type=style&index=0&id=07f1dfc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f1dfc6",
  null
  
)

export default component.exports